import React, {useState, useEffect} from 'react'
import toast, { Toaster } from 'react-hot-toast';
import { requestForToken, onMessageListener, ensureFirebaseMessagingServiceWorker } from './firebase';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { showLogoutModal, toggleAddProgrammePopup } from '../redux/reducers/view';
import { setRequestId, setResults, showTurnitinResults, turnitinEulaRequest, turnitinGenerateRequest, turnitinRequest } from '../redux/reducers/turnitin';
import { selectedContent } from '../redux/selectors';
import axios from 'axios';
import { selectAssessmentContent, setExamTime } from '../redux/reducers/userProgramsFull';
import { API_LINK, STATUSES } from '../constants';
import { contentItemSuccess } from "../redux/reducers/contentList";
import { logoutUserRequest } from '../redux/reducers/login';
const API = `${API_LINK}api/user`;
const NotificationFire = (props) => {
  const [notification, setNotification] = useState({title: '', body: ''});
  const notify = () =>  toast(<ToastDisplay/>,{
    duration: 4000,
    position: 'top-center'}); 

  function ToastDisplay() {
    return (
      <div style={{zIndex:100000000}}>
        <p><b>{notification?.title}</b></p>
        <p>{notification?.body}</p>
      </div>
    );
  }

  const parseFcmPayload = (payload) => {
    const title = payload?.notification?.title || payload?.data?.title;
    const body = payload?.notification?.body || payload?.data?.body;
    return { title, body };
  };

  const handleTurnitinSubmission = (obj) => {
    props.setRequestId(obj)

    if (obj.survey_id) {
      props.selectAssessmentContent({
        survey_id: obj.survey_id,
        module_id: obj.module_id,
        program_id: obj.program_id,
        rollout_id: obj.rollout_id,
        name: obj.name || obj.title,
        moduleName: obj.module_name || obj.moduleName,
        programName: obj.program_name || obj.programName,
        group_context_owners: obj.group_context_owners || obj.instructors,
      })
    }

    if(Number(obj.attempt)<Number(obj.submission_allowance) && obj.overall_match_percentage==null){
      props.turnitinRequest()
      return true;
    }

    return false;
  }

  useEffect(() => {
    if (notification?.title ){
     notify()
    }
  }, [notification])

  useEffect(() => {
    const userId = props.login?.user?.userId || props.login?.user?.id;

    if (!userId) {
      return undefined;
    }

    ensureFirebaseMessagingServiceWorker()
      .then(() => requestForToken(userId))
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('[FCM] service worker setup failed:', err);
      });
  }, [props.login?.user?.userId, props.login?.user?.id]);

  const refreshItem = async(library_id)=>{
    var result =  await axios({
      method: 'get',
      url: `${API}/${props.login.user.userId}/getComponent?component_id=${library_id}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${props.login.token}`,
      },
    })
    props.contentItemSuccess(result.data.data.component[0].content[0])
  }
  

  const handleFcmPayload = (payload) => {
    if(payload?.notification?.title=='tii_report_complete'){
      var results = JSON.parse(payload?.notification?.body)
      if(results.overall_match_percentage>25 && results.submission_count<results.submission_allowance){
        props.setResults(JSON.parse(payload?.notification?.body))
        props.showTurnitinResults(true)
        axios({
          method: 'post',
          url: API_LINK + 'api/updateAssessmentStatus?request_id='+results.request_id+'&status=ready',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          credentials: 'same-origin'
      })
      }
    }
    if(payload?.notification?.title=='tii_report_finished'){
      var tmp = JSON.parse(payload?.notification?.body)
      refreshItem(tmp.library_id)
    }
    if(payload?.notification?.title=='tii_submission_complete'){
      
      props.turnitinGenerateRequest()
     
    }
    if(payload?.notification?.title=='session_warning'){
      props.showLogoutModal(true)
    }
    if(payload?.notification?.title=='session_logout'){
      props.showLogoutModal(false)
      props.logout(true)
    }

    if(payload?.notification?.title=='exam_change'){
      setNotification({title:'Exam time changed', body: 'The exam now starts at '+JSON.parse(payload?.notification?.body).start_time+' and ends at '+JSON.parse(payload?.notification?.body).end_time});  
      requestForToken(props.login.user.userId);
      var tmp = JSON.parse(payload?.notification?.body)
      props.setExamTime(tmp)
      refreshItem(tmp.library_id)

    }

    if(payload?.notification?.title=='tii_submission'){
      var obj = JSON.parse(payload?.notification?.body)
      handleTurnitinSubmission(obj)
    }

    const { title, body } = parseFcmPayload(payload);
    if (title === 'tii_submission' && body && !payload?.notification?.title) {
      var submissionObj = JSON.parse(body);
      handleTurnitinSubmission(submissionObj);
    }
  };

  useEffect(() => {
    const swHandler = (event) => {
      if (event.data && event.data.type === 'FCM_MESSAGE' && event.data.payload) {
        handleFcmPayload(event.data.payload);
      }
    };

    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', swHandler);
    }

    const unsubscribe = onMessageListener(handleFcmPayload);

    return () => {
      if (navigator.serviceWorker) {
        navigator.serviceWorker.removeEventListener('message', swHandler);
      }
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, []);

  return (
     <Toaster/>
  )
}

const mapStateToProps = state => ({
  login: state.loginReducer,
  turnitin: state.turnitinReducer
});
const mapDispatchToProps = dispatch => ({
  toggleAddProgrammePopup: value => dispatch(toggleAddProgrammePopup(value)),
  setRequestId: value => dispatch(setRequestId(value)),
  turnitinEulaRequest: () => dispatch(turnitinEulaRequest()),
  turnitinRequest: () => dispatch(turnitinRequest()),
  showTurnitinResults: (bool) => dispatch(showTurnitinResults(bool)),
  showLogoutModal: (bool) => dispatch(showLogoutModal(bool)),
  logout: (bool) => dispatch(logoutUserRequest(bool)),
  setExamTime: (bool) => dispatch(setExamTime(bool)),
  contentItemSuccess: value => dispatch(contentItemSuccess(value)),
  turnitinGenerateRequest: () => dispatch(turnitinGenerateRequest()),
  selectAssessmentContent: value => dispatch(selectAssessmentContent(value)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(NotificationFire);
